import { createOutlineIcon } from "../createIcon";

export const XTriangleOutlineIcon = createOutlineIcon(
  <>
    <path d="M13.9992 15L11.9993 13M11.9993 13L9.99951 11M11.9993 13L9.99951 15M11.9993 13L13.9992 11M17.6699 20H6.33007C4.7811 20 3.47392 18.9763 3.06265 17.5757C2.88709 16.9778 3.10281 16.3551 3.43276 15.8249L9.10269 5.60102C10.4311 3.46632 13.5689 3.46633 14.8973 5.60103L20.5672 15.8249C20.8972 16.3551 21.1129 16.9778 20.9373 17.5757C20.5261 18.9763 19.2189 20 17.6699 20Z" />
  </>,
  "XTriangleOutlineIcon"
);
